<script setup lang="ts">
withDefaults(
  defineProps<{
    size?: number | string;
    color?: string;
    weight?: "regular" | "fill";
  }>(),
  {
    size: 24,
    color: "currentColor",
    weight: "regular",
  }
);
</script>

<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    :width="size"
    :height="size"
    :fill="color"
    v-bind="$attrs"
  >
    <path
      v-if="weight === 'regular'"
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M12 1.59998C9.29381 1.59998 7.10001 3.79378 7.10001 6.49998V8.59998H6.00001C4.95067 8.59998 4.10001 9.45063 4.10001 10.5V20.5C4.10001 21.5493 4.95067 22.4 6.00001 22.4H18C19.0493 22.4 19.9 21.5493 19.9 20.5V10.5C19.9 9.45063 19.0493 8.59998 18 8.59998H16.9V6.49998C16.9 3.79378 14.7062 1.59998 12 1.59998ZM15.1 8.59998V6.49998C15.1 4.78789 13.7121 3.39998 12 3.39998C10.2879 3.39998 8.90001 4.78789 8.90001 6.49998V8.59998H15.1ZM5.90001 10.5C5.90001 10.4447 5.94478 10.4 6.00001 10.4H18C18.0552 10.4 18.1 10.4447 18.1 10.5V20.5C18.1 20.5552 18.0552 20.6 18 20.6H6.00001C5.94478 20.6 5.90001 20.5552 5.90001 20.5V10.5Z"
    />
    <path
      v-else-if="weight === 'fill'"
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M12 1.59998C9.29381 1.59998 7.10001 3.79378 7.10001 6.49998V8.59998H6.00001C4.95067 8.59998 4.10001 9.45063 4.10001 10.5V20.5C4.10001 21.5493 4.95067 22.4 6.00001 22.4H18C19.0493 22.4 19.9 21.5493 19.9 20.5V10.5C19.9 9.45063 19.0493 8.59998 18 8.59998H16.9V6.49998C16.9 3.79378 14.7062 1.59998 12 1.59998ZM15.1 8.59998V6.49998C15.1 4.78789 13.7121 3.39998 12 3.39998C10.2879 3.39998 8.90001 4.78789 8.90001 6.49998V8.59998H15.1Z"
    />
  </svg>
</template>
